export class AddSectionTypeDto {

    name?: string;
}